import Cookies from 'js-cookie';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';

class EscalationLevelService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.ESCALATION_LEVEL = '/api/escalation-level';

        this.GET_BY_KAIZIQ_RESOLVE_CONNECTION = '/list/{kaiziqResolveConnectionId}';
        this.UPDATE_LEVEL = '/update';
        this.CREATE_LEVEL = '/create';
        this.DELETE_LEVEL = '/delete';
    }

    async getListByConnectionId(kaiziqResolveConnectionId) {
        try {
            let url = window.location.origin + this.ESCALATION_LEVEL + this.GET_BY_KAIZIQ_RESOLVE_CONNECTION;
            url = url
                .replace('{kaiziqResolveConnectionId}', kaiziqResolveConnectionId)
            const escalationLevelsList = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return escalationLevelsList;
        } catch (err) {
            console.log(err);
        }
    }

    async createLevelAndPolicy(bodyObj) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.ESCALATION_LEVEL + this.CREATE_LEVEL;
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(bodyObj)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async updateEscalationLevel(updateMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.ESCALATION_LEVEL + this.UPDATE_LEVEL;
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(updateMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async deleteEscalationLevel(bodyObj) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.ESCALATION_LEVEL + this.DELETE_LEVEL;
        try{
            return this.fetch(url, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(bodyObj)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }
}

export default EscalationLevelService;
